import { createAction } from 'redux-actions';

import { PaymentStatus } from '../types';

export const SET_PAYMENT_STATUS = 'EXCHANGE/SET_PAYMENT_STATUS';
export const CLEAR_PAYMENT_STATUS = 'EXCHANGE/CLEAR_PAYMENT_STATUS';

export const setPaymentStatus = createAction<PaymentStatus>(SET_PAYMENT_STATUS);

export type SetPaymentStatusAction = ReturnType<typeof setPaymentStatus>;

export const clearPaymentStatus = createAction(CLEAR_PAYMENT_STATUS);

export type ClearPaymentStatusAction = ReturnType<typeof clearPaymentStatus>;
